import gql from 'graphql-tag';

export const PointOfInterestFragments = {
  id: gql`
    fragment PointOfInterestId on PointOfInterest {
      _id: externalId
    }
  `,
};
